<template>
  <app-confirm-dialog
    v-model="dialog"
    @confirm="confirm"
    @cancel="cancel"
    confirmBtnText="結束分享"
    cancelBtnText="取消"
    maxWidth="320"
    :loading="loading"
    :showConfirmBtn="showConfirmBtn"
    :showCancelBtn="showCancelBtn">
    <span class="subheading">{{dialogText}}</span>
    <template slot="action">
      <v-btn
        v-show="showCancelInvtieBtn"
        @click="cancelInvite"
        flat>
        取消邀請
      </v-btn>
    </template>
  </app-confirm-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

const getDefaultData = () => {
  return {
    loading: false,
    dialog: false,
    dialogText: '是否結束分享?',
    showConfirmBtn: true,
    showCancelBtn: true,
    showCancelInvtieBtn: false
  };
};

export default {
  data: getDefaultData,
  computed: {
    ...mapState('fudao', {
      fudaoDto: state => state.fudaoDto,
      fudaoSession: state => state.fudaoSession,
      responseTimeout: state => state.responseTimeout
    })
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.reset();
      }
    }
  },

  mounted() {
  },

  beforeDestory() {
    this.reset();
  },

  methods: {
    ...mapActions('alert', {
      addAlert: 'add'
    }),

    isDifferentFudao(domainEvent) {
      return this.fudaoDto.id !== domainEvent.entityId;
    },

    open() {
      this.dialog = true;
    },

    reset() {
      this.$eventBus.$off(FudaoEvent.StudentEndSessionInvitationAccepted, this.onStudentEndSessionInvitationAccepted);
      this.$eventBus.$off(FudaoEvent.StudentEndSessionInvitationRejected, this.onStudentEndSessionInvitationRejected);
      this.$eventBus.$off(FudaoEvent.StudentEndSessionInvitationNoReponse, this.onStudentEndSessionInvitationNoReponse);
      this.$eventBus.$off(FudaoEvent.FudaoSessionFailed, this.onFudaoSessionFailed);

      clearTimeout(this._timeout);
      let data = getDefaultData();
      Object.keys(data).forEach(key => this[key] = data[key]);
    },

    async confirm() {
      this.loading = true;
      this.$eventBus.$on(FudaoEvent.StudentEndSessionInvitationAccepted, this.onStudentEndSessionInvitationAccepted);
      this.$eventBus.$on(FudaoEvent.StudentEndSessionInvitationRejected, this.onStudentEndSessionInvitationRejected);
      this.$eventBus.$on(FudaoEvent.StudentEndSessionInvitationNoReponse, this.onStudentEndSessionInvitationNoReponse);
      this.$eventBus.$on(FudaoEvent.FudaoSessionFailed, this.onFudaoSessionFailed);

      await fudaoAppService.inviteEndFudaoSessionAsync(this.fudaoDto.id, this.fudaoSession);

      this.dialogText = '已送出結束邀請，等待對方回應...';
      this.showConfirmBtn = false;
      this.showCancelBtn = false;
      this.showCancelInvtieBtn = true;

      this._timeout = setTimeout(() => {
        this.sentNoResponse();
      }, this.responseTimeout);
    },

    cancel() {
      this.dialog = false;
    },

    async cancelInvite() {
      clearTimeout(this._timeout);
      await fudaoAppService.cancelFudaoEndSessionInvitionAsync(this.fudaoDto.id, this.fudaoSession);
      this.dialog = false;
    },

    sentNoResponse() {
      fudaoAppService.noResponseFudaoEndSessionInvitionAsync(this.fudaoDto.id, this.fudaoSession);
    },

    // events -------------------------------------

    async onStudentEndSessionInvitationAccepted(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }

      clearTimeout(this._timeout);
      await fudaoAppService.endFudaoSessionAsync(this.fudaoDto.id, this.fudaoSession);
      this.dialog = false;
    },

    onStudentEndSessionInvitationRejected(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'info', content: '學生拒絕結束邀請'});
      this.dialog = false;
    },

    onStudentEndSessionInvitationNoReponse(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'warning', content: '邀請結束分享無回應'});
      this.dialog = false;
    },

    onFudaoSessionFailed(errMsg) {
      this.addAlert({level: 'error', content: '邀請結束分享發生錯誤: ' + errMsg});
    }
  }
};
</script>